export enum RouteType {
  '/poc-orders' = 'ORDERS',
  '/home' = 'HOMEPAGE',
  '/orders-map' = 'ADDRESS_MAP',
  '/my-account' = 'PROFILE',
  '/inventory' = 'INVENTORY',
  '/history' = 'ORDER_HISTORY',
  '/order/%s' = 'ORDER_DETAIL',
}

export const NOT_TRACKED = 'NOT_TRACKED'

export const routeRegex = new RegExp('/order/[0-9]+')
